import { render, staticRenderFns } from "./ProjEdit.vue?vue&type=template&id=3f6bb9b6&scoped=true"
import script from "./ProjEdit.vue?vue&type=script&lang=js"
export * from "./ProjEdit.vue?vue&type=script&lang=js"
import style0 from "./ProjEdit.vue?vue&type=style&index=0&id=3f6bb9b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6bb9b6",
  null
  
)

export default component.exports